export const inr = (value) => `₹${Number(value || 0).toLocaleString("en-IN")}`;
export const short = (value, length = 80) => (String(value || "").length > length ? `${String(value).slice(0, length - 1)}…` : String(value || ""));
export const statusColor = (status) => ({ active: "bg-emerald-400", stopped: "bg-zinc-500", error: "bg-red-500" }[status] || "bg-zinc-500");
